import { EventEmitter, Injectable } from "@angular/core";
import { RestService } from "src/app/Services/Rest/rest.service";
import {
  login_body,
  getOTP_body,
  productInfo_body,
  apiURLAruhat,
  apiURL,
  loadViewConfig_body,
} from "src/app/common";
import {
  commonConstants,
  RoutesAll,
  RequestURL,
  Cookies,
  lender,
} from "src/app/Constants/app.constants";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { KeycloakService } from "keycloak-angular";
import { Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { AuthenticationService } from "./authentication.service";

export class AddOrder {
  constructor(
    public PAN?: any,
    public entityName?: any,
    public method?: any,
    public type: any = null,
    public toEmail: string = "",
    public ccEmail: string = ""
  ) {}
}

export class AddMail {
  constructor(public email_to: [], public email_cc: string) {}
}

@Injectable()
export class OrderService {
  customHttpDefaultOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Access-Control-Request-Method": "GET,POST,PUT,DELETE,OPTIONS",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin,Content-Type,Accept,X-Requested-With",
    }),
  };
  userProductsDetails: any;
  is_gstdigitalpdf_access : boolean = false;

  constructor(
    private restService: RestService,
    private router: Router,
    private httpClient: HttpClient,
    protected keycloakAngular: KeycloakService,
    private _service: AuthenticationService
  ) {
    if (this.keycloakAngular.getKeycloakInstance().idToken != undefined) {
      try {
        console.log("calling order services");
        let token = this.keycloakAngular.getKeycloakInstance().idToken;
        this.keycloakAngular
          .getKeycloakInstance()
          .loadUserProfile()
          .then((profile) => {
            let userDetails =
              this.keycloakAngular.getKeycloakInstance().profile;
            let userAttributes = userDetails["attributes"];
            this._service.setCookies(
              Cookies.apiToken,
              userAttributes.api_auth_token[0],
              7
            );
            this._service.setCookies(
              Cookies.userId,
              userAttributes.user_id[0],
              7
            );
            this._service.setCookies(
              Cookies.displayName,
              userAttributes.display_name,
              7
            );
            this._service.setCookies(
              Cookies.corporateId,
              userAttributes.corporate_id[0],
              7
            );
            this._service.setCookies(
              Cookies.corporateName,
              userAttributes.corporate[0],
              7
            );
            if (userDetails.email != null) {
              this._service.setCookies(
                Cookies.lenderEmail,
                userDetails.email,
                7
              );
            }
            localStorage.setItem("userId", userAttributes.user_id[0]);
            localStorage.setItem(
              "referenceNo",
              userAttributes.term_reference_no[0]
            );
            if (userDetails.firstName != null) {
              this._service.setCookies(
                Cookies.userName,
                userDetails.firstName,
                7
              );
            }

            this.getUserProductDetails(() => {});
            this.getLoadViewConfig();
          });
      } catch (e) {
        console.log("Failed to load user details", e);
      }
    }
    // this.getUserProductDetails(() => {});
  }
  navchange: EventEmitter<any> = new EventEmitter();

  placeOrderChange: EventEmitter<any> = new EventEmitter();

  resetSearchForLogoClick: EventEmitter<any> = new EventEmitter();

  submitLoginEvent: EventEmitter<any> = new EventEmitter();
  eventForGetErrorFiles: EventEmitter<any> = new EventEmitter();

  // dialog Close event Emitters
  uploadGSTPDF: EventEmitter<any> = new EventEmitter();
  uploadPDFPage: EventEmitter<any> = new EventEmitter();
  fileUploadPage: EventEmitter<any> = new EventEmitter();
  automaticActivityModal: EventEmitter<any> = new EventEmitter();

  isTokenValid() {
    let body = {
      user_id: localStorage.getItem("userId"),
      api_auth_token: this.keycloakAngular.getKeycloakInstance().idToken,
    };

    this.restService.isTokenValid(body, (data: any) => {
      if (!data) {
        location.reload();
      }
    });
  }

  setCookies(cname: any, cvalue: any, exdays: any) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookies(cname: any) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  logout() {
    this.setCookies(Cookies.userId, "", 0);
    this.setCookies(Cookies.apiToken, "", 0);
    this.setCookies(Cookies.userEmailAddress, "", 0);
    this.setCookies(Cookies.gstEmailAddress, "", 0);
    this.setCookies(Cookies.gstusername, "", 0);
    this.setCookies(Cookies.gstin, "", 0);
    this.setCookies(Cookies.userName, "", 0);
    this.setCookies(Cookies.displayName, "", 0);
    this.setCookies(Cookies.corporateId, "", 0);
    this.setCookies(Cookies.fromDate, "", null);
    this.setCookies(Cookies.toDate, "", null);
    this.setCookies(Cookies.lenderEmail, "", 0);
    // this.router.navigate([RoutesAll.authLogin]);

    let refereceNo = localStorage.getItem("referenceNo");
    let userId = localStorage.getItem("userId");
    let logout_body = {
      request: "web/logout",
      para: {
        term_reference_no: refereceNo,
        user_id: userId,
      },
    };

    this.restService.postRestAPICall(logout_body, (data: any) => {});

    this.keycloakAngular.getKeycloakInstance().logout();
  }

  getAllCurency(requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);
    let req_Obj: any;
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "text/plain",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      req_Obj,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  getMethod(requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);
    let req_Obj: any;
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "text/plain",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      req_Obj,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  getAllReport3(data: any): Observable<any> {
    console.log("get api");
    return this.httpClient
      .get("http://64.225.116.40:8080/gstin/rest/customer/message")
      .pipe(
        tap((data: any) =>
          console.log(`***** Operation Performed Successfully` + data)
        ),
        (error) => data("get api " + this.handleError(error))
      );
  }

  getAllReport(requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);
    let req_Obj: any;
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "text/plain",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      req_Obj,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  getAllOrder(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  placeOrder(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  getAllEntityGstint(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  addMailToSend(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }
  sendLink(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  deleteMail(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  downloadReport(reuqestBody: any, requestURL: any, cb: any) {
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  getUserProductDetails(cb: any) {
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    productInfo_body.para.user_id = this.getCookies(Cookies.userId);
    productInfo_body.para.api_auth_token = this.getCookies(Cookies.apiToken);
    this.restService.postRestCallClient(
      productInfo_body,
      apiURLAruhat,
      (data: any) => {
        if (data) {
          this.userProductsDetails = data.data;
          cb(data);
        }
      },
      customHttpHeader
    );
  }

  getLoadViewConfig()
  {
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    loadViewConfig_body.para.user_id = this.getCookies(Cookies.userId);
    loadViewConfig_body.para.api_auth_token = this.getCookies(Cookies.apiToken)+'|'+this.keycloakAngular.getKeycloakInstance().idToken;
    
    this.restService.getLoadViewConfig(loadViewConfig_body,customHttpHeader).subscribe(res =>{
      if(res && res['view_config'])
      {
        this.is_gstdigitalpdf_access = res['view_config']['is_gstdigitalpdf_access'];
      }
    })
  }

  

  private handleError(error: any) {
    // alert("error fun"+error.status)
    // alert("error fun"+error.description)
    // alert(JSON.stringify(error))
    console.log("ERROR" + error);
    let description = "There was an error: " + error.status;
    return {
      status: error.status,
      //message: error.message,
      errordescription: description,
    };
  }

  redirectToHomePage() {
    this.router.navigate([RoutesAll.lender]);
  }

  redirectToAddCustomer() {
    this.setCookies(Cookies.fromDate, "", null);
    this.setCookies(Cookies.toDate, "", null);
    this.router.navigate([RoutesAll.authAddCustomer]);
  }
  redirectToAddOrder() {
    this.router.navigate([RoutesAll.getconsent]);
  }
  getEntityDetailPageData(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }
  downloadErrorFile(demo: any, files: any, requestURL: any, cb: any) {
    let customHttpHeader = {
      responseType: "blob",
      headers: new HttpHeaders({
        //			'Content-Type': 'application/json',
      }),
    };
    var formData = new FormData();

    formData.append("panNo", demo);
    formData.append("files", files);
    this.restService.postRestCall(
      formData,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  //uplaod a gst pdf
  uploadGStPdf(
    requestURL: any,
    uploadGStpdf: any,
    attachFiles: any,
    cb: any
  ): Observable<any> {
    var formData = new FormData();

    formData.append("userwoidbean", JSON.stringify(uploadGStpdf));

    // formData.append("files", attachFiles[0]);

    attachFiles.forEach(function (file: any) {
      formData.append("files", file);
    });

    //   attachFiles.forEach(file => {
    //     formData.append('files', file, file.name);
    //  })
    //   var formData = new FormData();
    //   formData.append("userwoidbean", JSON.stringify(uploadGStpdf));
    // // for (let i = 0; i < attachFiles.length; i++) {
    // //   formData.append('files', attachFiles, attachFiles[i].name);
    // // }

    //   formData.append("files", attachFiles[0]);

    let customHttpHeader = {
      headers: new HttpHeaders({
        // 'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Headers': 'Content-Type',
        // 'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
        // 'Authorization': 'Bearer szdp79a2kz4wh4frjzuqu4sz6qeth8m3',
      }),
    };

    // this.restService.postRestCallClient(formData, requestURL, data => {
    //   cb(data);
    // }, customHttpHeader);

    this.restService.postRestCallClient(
      formData,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );

    return new Observable<null>(); //this.httpClient.doPost(URL.uploadGSTPdfURL, formData);
  }

  checkIfOrderValidOrNot(requestURL: any, isOrderValid: any, cb: any) {
    let customHttpHeader = {
      headers: new HttpHeaders({
        // 'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Headers': 'Content-Type',
        // 'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
        // 'Authorization': 'Bearer szdp79a2kz4wh4frjzuqu4sz6qeth8m3',
      }),
    };
    this.restService.postRestCallClient(
      isOrderValid,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
    return null;
  }

  downloadExcelFile(body: any, downloadExcelURL: any, data: any) {
    this.restService.postRestCallBlob(
      apiURL + downloadExcelURL,
      body,
      (response: any) => {
        data(response);
      }
    );
  }

  emitNavChangeEvent(data: any) {
    this.navchange.emit(data);
  }
  getNavChangeEmitter() {
    return this.navchange;
  }

  //service when we place an order
  emitChangeEvent(data: any) {
    this.placeOrderChange.emit("true");
  }

  getChangeEmitter() {
    return this.placeOrderChange;
  }
  getErrorFileList(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  //call event emitter while click on logo and reset the search
  emitChangeEventForLogoClick(data: any) {
    this.resetSearchForLogoClick.emit("true");
  }

  getChangeEmitterForLogoClick() {
    return this.resetSearchForLogoClick;
  }

  fetchSystemPreferances(requestURL: any, cb: any) {
    let customHttpHeader = {
      responseType: "text",
      headers: new HttpHeaders({
        //			'Content-Type': 'application/json',
      }),
    };
    this.restService.getRestCall(
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  fetchStatus(requestBody: any, requestURL: any, cb: any) {
    let customHttpHeader = {
      // responseType: 'application/json',
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    this.restService.postRestCall(
      requestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  fetchStatusForGST(requestBody: any, requestURL: any, cb: any) {
    let customHttpHeader = {
      // responseType: 'application/json',
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    this.restService.postRestCall(
      requestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  /**
   * this service will fetch order due date
   * from the system settings
   * @param requestURL
   * @param cb
   */
  fetchOrderDueDate(requestURL: any, cb: any) {
    let customHttpHeader = {
      responseType: "text",
    };
    this.restService.getRestCall(
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  /**
   * this service will fetch disclaimer text if disclaimer property is ON
   * from the system settings
   * @param requestURL
   * @param cb
   */
  fetchDisclaimerProperty(requestURL: any, cb: any) {
    let customHttpHeader = {
      responseType: "text",
    };
    this.restService.getRestCall(
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }
}
